import { render, staticRenderFns } from "./technology.kr.vue?vue&type=template&id=1c63acfa&"
import script from "./technology.kr.vue?vue&type=script&lang=js&"
export * from "./technology.kr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports